import { Percent } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import TMPContent from '../components/TMPContent';

/**
 * Page TMP - Calcul du Taux Moyen Pondéré
 * Structure de la page avec titre et sous-titre
 */
export default function TMPPage() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      fontFamily: '"Noto Sans", sans-serif'
    }}>
      <PageHeader
        icon={Percent}
        title="Calcul du Taux Moyen Pondéré"
        subtitle="TMP = CA total GIE / Jours totaux GIE"
      />

      {/* Contenu principal */}
      <TMPContent />
    </div>
  );
}
